/**
 * Combines active-subscription and free-access-whitelist status into a single
 * "does this user have premium access" signal. `loading` only reflects the
 * subscription lookup (the whitelist listener has no separate loading state),
 * matching how the two were previously combined ad hoc at each call site.
 */
import { useHasActiveSubscription } from './useSubscription';
import { useIsFreeAccessWhitelisted } from './useFreeAccessWhitelist';

export function useIsPremium(email: string | null): {
  isPremium: boolean;
  loading: boolean;
} {
  const { hasActiveSubscription, loading } = useHasActiveSubscription();
  const isWhitelisted = useIsFreeAccessWhitelisted(email);
  return { isPremium: hasActiveSubscription || isWhitelisted, loading };
}
